// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4652":"8b619f5b","4818":"f3a8e20d","5590":"c7ee854d","6237":"e624d998"}[chunkId] + ".chunk.css";
};